import { Component, OnInit } from '@angular/core';
import {Simulador} from '../../classes/simulador';
import {Router} from '@angular/router';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit {

  constructor(private simulador: Simulador, public router: Router) {
    simulador.index = true;
  }

  ngOnInit() {
  }

  irparaform(){
    this.router.navigate(['/formulario'], { skipLocationChange: true });
  }
}
